import Vue from 'vue'
import Router from 'vue-router'
import Home from './views/webPortal/Home.vue'
import Recruit from './views/webPortal/recruit.vue'
import Contact from './views/webPortal/contact.vue'
import Search from './views/webPortal/search.vue'
import Csr from './views/webPortal/csr.vue'

import Company from './views/webPortal/company/index.vue'
import Company_Greetings from './views/webPortal/company/greetings.vue'
import Company_Philosophy from './views/webPortal/company/philosophy.vue'
import News from './views/webPortal/news/news.vue'
import NewsDetails from './views/webPortal/news/news_details.vue'


import Product from './views/webPortal/product/index.vue'
import ProductGroup from './views/webPortal/product/product_group.vue'
import ProductDetail from './views/webPortal/product/product_details.vue'
// import ProductEasy from './views/webPortal/product/easy.vue'
// import ProductEasyDeatail from './views/webPortal/product/product_easy_details.vue'
import ProductEasySearch from './views/webPortal/product/easy_search.vue'





import WebPortal from './views/webPortal/index.vue'
import f_f from './views/404.vue'

import Admin from './views/admin/index.vue'
import AdminHome from './views/admin/home.vue'
import AdminCompany from './views/admin/company.vue'
import AdminPictures from './views/admin/pictures.vue'
import AdminNews from './views/admin/news.vue'
import AdminProduct from './views/admin/product.vue'
import AdminRecruit from './views/admin/recruit.vue'
import AdminMsg from './views/admin/msg.vue'
import AdminEasy from './views/admin/easy.vue'
import AdminCsr from './views/admin/csr.vue'


Vue.use(Router)

export default new Router({
  mode: 'history',
  // base: '/newlong/',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/',
      name: 'web_portal',
      component: WebPortal,
      children: [{
        path: '/',
        name: 'home',
        component: Home,
        // meta:{
        //   keepAlive: false
        // }
      },
      {
        path: '/search',
        name: 'search',
        component: Search
      },
      {
        path: '/csr',
        name: 'csr',
        component: Csr
      },
      {
        path: '/company',
        name: 'company',
        component: Company
      },
      {
        path: '/company/greetings',
        name: 'greetings',
        component: Company_Greetings
      },
      {
        path: '/company/philosophy',
        name: 'philosophy',
        component: Company_Philosophy
      },
      {
        path: '/news',
        name: 'news',
        component: News
      },
      {
        path: '/news/:id',
        name: 'news_details',
        component: NewsDetails
      },
      {
        path: '/units',
        name: 'product',
        component: Product
      },
      {
        path: '/units/:type',
        name: 'product_group',
        component: ProductGroup
      },
      {
        path: '/easy/search',
        name: 'product_easy_search',
        component: ProductEasySearch
      },
      {
        path: '/units/:type/:key',
        name: 'product_detail',
        component: ProductDetail
      },
      {
        path: '/units/:type/:key/:ckey',
        name: 'product_detail2',
        component: ProductDetail
      },
      {
        path: '/recruit',
        name: 'recruit',
        component: Recruit
      },
      {
        path: '/contact',
        name: 'contact',
        component: Contact
      },
    ]
    },
    {
      path: '/a/admin',
      name: 'Admin',
      component: Admin,
      children: [
        {
          path: '/a/admin',
          name: 'AdminHome',
          component: AdminHome
        }, {
          path: '/a/admin/company',
          name: 'AdminCompany',
          component: AdminCompany
        }, {
          path: '/a/admin/pictures',
          name: 'AdminPictures',
          component: AdminPictures
        }, {
          path: '/a/admin/news',
          name: 'AdminNews',
          component: AdminNews
        }, {
          path: '/a/admin/product',
          name: 'AdminProduct',
          component: AdminProduct
        }, {
          path: '/a/admin/recruit',
          name: 'AdminRecruit',
          component: AdminRecruit
        }, {
          path: '/a/admin/msg',
          name: 'AdminMsg',
          component: AdminMsg
        }, {
          path: '/a/admin/easy',
          name: 'AdminEasy',
          component: AdminEasy
        }, {
          path: '/a/admin/csr',
          name: 'AdminCsr',
          component: AdminCsr
        },
      ]
    },
    //-----------------
    // {
    //   path: '*',
    //   component: f_f
    // }
    // {
    //   path: '/about',
    //   name: 'about',
    //   // route level code-splitting
    //   // this generates a separate chunk (about.[hash].js) for this route
    //   // which is lazy-loaded when the route is visited.
    //   component: () => import(/* webpackChunkName: "about" */ './views/About.vue')
    // }
  ]
})
